import { TableBody, TableCell, TableRow, Button } from "@windmill/react-ui";
import BillDrawer from "components/drawer/PurchasebillDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import PurchasebillServices from "services/PurchasebillServices";
import ViewModal from "components/modal/ViewBillModal";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import { MdClose } from "react-icons/md"; // Import MdClose from react-icons
import { notifyError, notifySuccess } from "utils/toast";
import React, { useState, useContext } from "react";
import Tooltip from "@mui/material/Tooltip";
import useToggleDrawer from "hooks/useToggleDrawer";
import { SidebarContext } from "context/SidebarContext";
import RemarkModal from "components/modal/RemarkModal";
import DriverAproveRejectModel from "components/modal/DriverAproveRejectModel";
import DriverVerifyorApprovedModal from "components/modal/DriverVerifyorApproveModal";
import PaidDetailsModal from "components/modal/PaidDetailsModal";
import { FiEye, FiFile } from "react-icons/fi";
import ItineraryModal from "components/form/ItineraryModal";
import Cookies from "js-cookie";
import { IoIosClose } from "react-icons/io";
import { FaInfoCircle } from "react-icons/fa";
const adminInfo = Cookies.get("adminInfo")
  ? JSON.parse(Cookies.get("adminInfo"))
  : null;
const id_employee = adminInfo?.id ? adminInfo.id : 0;

const DriverTable = ({
  driver,
  perpage,
  currentPage,
  tab,
  hideAdd,
  hideEdit,
  hideDelete,
  hideView,
  hideExport,
}) => {
  const { title, serviceBlock, serviceId, handleView } = useToggleDrawer();
  const [open, setOpen] = useState(false);
  const [, setSelectedDriver] = useState(null);
  const [isRemarkModalOpen, setIsRemarkModalOpen] = useState(false);
  const [remarkModalData, setRemarkModalData] = useState(null);
  const [billStatus, setBillStatus] = useState(null);
  const [selectedRemark, setSelectedRemark] = useState("");
  const [type, setType] = useState(null);
  const { setIsUpdate } = useContext(SidebarContext);
  const { toggleDrawer } = useContext(SidebarContext);
  const [billData, setBilldata] = useState();
  const [isPaidModalOpen, setIsPaidModalOpen] = useState(false);
  const [paidDetails, setPaidDetails] = useState(null);
  const [itinerary, setItinerary] = useState("");
  const [showItineraryModal, setShowItineraryModal] = useState(false);
  // internal imports
  const renderImage = (imgUrl, index, onClickHandler) => (
    <img
      key={index}
      src={process.env.REACT_APP_API_IMAGE_URL + imgUrl}
      alt={`Bill Image ${index + 1}`}
      onClick={onClickHandler}
      className="w-12 h-12 object-cover rounded mr-2 cursor-pointer inline-block border border-gray-300 hover:scale-105 transition-transform"
    />
  );

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const openZoomModal = (image) => {
    setSelectedImage(image);
    setIsModalOpen(true);
  };

  const closeZoomModal = () => {
    setSelectedImage(null);
    setIsModalOpen(false);
  };
  const handlePaidModalOpen = (details) => {
    setPaidDetails(details);
    setIsPaidModalOpen(true);
  };

  const handlePaidModalClose = () => {
    setIsPaidModalOpen(false);
    setPaidDetails(null);
  };

  const handleOpen = (remark) => {
    setSelectedRemark(remark);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handleBill = async (data) => {
    setBilldata(data);
  };
  const handleVerify = async (data) => {
    const payload = {
      bill_amount: data.bill_amount,
      client_id: data.client_id,
    };

    try {
      const res = await PurchasebillServices.checkRate(data.va_id, payload);
      if (res.data.bill === "loss") {
        setBillStatus("loss");
      } else {
        setBillStatus(res.data.bill);
      }
      setRemarkModalData(data);
      setType("checkrate");
      setIsRemarkModalOpen(true);
    } catch (error) {
      console.error("Error in handleVerify:", error);
      notifyError("Failed to verify the bill.");
    }
  };
  const handleApprove = async (data) => {
    setRemarkModalData(data);
    setIsRemarkModalOpen(true);
    setType("checkapprove");
  };

  const handleModalAction = async (action, remark, data, type) => {
    try {
      if (type === "checkrate") {
        var payload = {};

        if (action === "approve") {
          payload.bill_verify_status = "1";
          payload.bill_amount = data.bill_amount;
        } else if (action === "reject") {
          payload.bill_verify_status = "2";
          payload.reject_reason = remark;
        }
        // payload.client_id = data.client_id;
        // payload.id_employee = id_employee;

        const response = await PurchasebillServices.updateverifyStatus(
          data.va_id,
          payload,
        );

        if (response.status) {
          setIsUpdate(true);
          return notifySuccess(response.message);
        } else {
          return notifyError(response.message);
        }
      }
      if (type === "checkapprove") {
        var payloads = {};

        if (action === "approve") {
          payloads.bill_approve_status = "1";
        } else if (action === "reject") {
          payloads.bill_approve_status = "2";
          payloads.reject_reason = remark;
        }

        // payloads.client_id = data.client_id;
        // payloads.id_employee = id_employee;

        const response = await PurchasebillServices.updateapproveStatus(
          data.va_id,
          payloads,
        );

        if (response.status) {
          setIsUpdate(true);
          return notifySuccess(response.message);
        } else {
          return notifyError(response.message);
        }
      }
    } catch (error) {
      console.error("Error updating status:", error);
      return notifyError("Error updating status.");
    } finally {
      setIsRemarkModalOpen(false);
      setSelectedDriver(null);
    }
  };
  // const driverHistory = selectedDriver && driver?.find((d) => d.id === selectedDriver.id)?.driverHistory;

  return (
    <>
      <PaidDetailsModal
        open={isPaidModalOpen}
        onClose={handlePaidModalClose}
        details={paidDetails}
      />
      <ItineraryModal
        isOpen={showItineraryModal}
        content={itinerary}
        onClose={() => setShowItineraryModal(false)}
      />
      <RemarkModal
        id_data={serviceId}
        block_data={serviceBlock}
        title_data={title}
      ></RemarkModal>
      <DeleteModal id={serviceId} title={title} />
      {hideView && <ViewModal id={serviceId} title={title} data={driver} />}

      <MainDrawer>
        <BillDrawer id={serviceId} data={billData} tab={tab} />
      </MainDrawer>

      {/* {isRemarkModalOpen && (
				<DriverAproveRejectModel

					isOpen={isRemarkModalOpen}
					data={remarkModalData} // Pass the selected data to the modal
					type={type}
					billStatus={billStatus}
					onClose={() => setIsRemarkModalOpen(false)}
					title="Approve or Reject"
					onYesClick={() =>
						handleModalAction('approve', 'Approved', remarkModalData, type)
					} // Default remark for testing
					onRejectClick={(remark) => {
						handleModalAction('reject', remark, remarkModalData, type);
					}}
				/>
			)} */}

      {isRemarkModalOpen && (
        <DriverVerifyorApprovedModal
          isOpen={isRemarkModalOpen}
          data={remarkModalData}
          type={type}
          billStatus={billStatus}
          onClose={() => setIsRemarkModalOpen(false)}
          title={
            type === "checkrate" ? "Verify or Unverify" : "Approve or Reject"
          }
          approveText={type === "checkrate" ? "Verify" : "Approve"}
          rejectText={type === "checkrate" ? "Unverify" : "Reject"}
          onYesClick={() =>
            handleModalAction("approve", "Approved", remarkModalData, type)
          }
          onRejectClick={(remark) => {
            handleModalAction("reject", remark, remarkModalData, type);
          }}
        />
      )}

      <TableBody>
        {driver?.slice(0, perpage).map((data, index) => (
          // <TableRow key={data.client_id}>
          <TableRow
            key={index}
            className={
              data.booking_status === 1 ? "bg-red-100 dark:bg-gray-500" : ""
            }
          >
            <TableCell className="text-sm text-center">
              {(currentPage - 1) * perpage + index + 1}
            </TableCell>

            <TableCell className="text-sm text-center">{data.ref_no}</TableCell>

            <TableCell className="text-sm text-center">
              {data.client_name}
            </TableCell>

            <TableCell className="text-sm text-center">
              <p className="flex flex-col row-gap-4">
                <span>{data.start_date}</span>

                <span>{data.end_date}</span>
              </p>
            </TableCell>
            {(tab === 2 || tab === 3) && (
              <TableCell className="text-center">
                {data.selling_price}
              </TableCell>
            )}
            {tab != 0 && (
              <TableCell className="text-center text-sm">
                {data.itinerary && (
                  <span className="text-sm cursor-pointer flex justify-center items-center">
                    <span
                      onClick={() => {
                        setShowItineraryModal(true);
                        setItinerary(data.itinerary);
                      }}
                      title="Itinerary"
                    >
                      <FiFile className="text-2xl text-green-500 hover:text-green-600" />
                    </span>
                  </span>
                )}
              </TableCell>
            )}
            <TableCell className="text-center text-sm">
              {data.vendor_name}
            </TableCell>

            <TableCell className="text-center text-sm">
              <Tooltip
                title={
                  <div>
                    {data.trip_advance?.map((paid, i, arr) =>
                      paid && paid.trip_advance_paid !== 0 ? (
                        <div
                          key={`trip-${i}-${paid.utr || "default"}`}
                          className="mb-2"
                        >
                          <div>
                            <strong>Trip Advance:</strong>{" "}
                            {paid.trip_advance_paid || "N/A"}
                          </div>
                          <div>
                            <strong>Date:</strong> {paid.paid_date || "N/A"}
                          </div>
                          <div>
                            <strong>Type:</strong> {paid.payment_type || "N/A"}
                          </div>
                          <div>
                            <strong>UTR:</strong> {paid.utr || "N/A"}
                          </div>
                          <div>
                            <strong>Remarks:</strong>{" "}
                            {paid.paid_remark || "N/A"}
                          </div>
                          {i !== arr.length - 1 && <hr className="my-2" />}
                        </div>
                      ) : null,
                    )}
                  </div>
                }
                placement="top-start"
                arrow
              >
                <span className="text-black-600 cursor-pointer">
                  {data.total_trip_advance_paid}
                </span>
              </Tooltip>
            </TableCell>
            {tab != 0 && (
              <TableCell className="text-center">{data.bill_amount}</TableCell>
            )}
            {tab != 0 && (
              <TableCell className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                {Array.isArray(data?.bill_images)
                  ? data.bill_images.map((image, i) =>
                      renderImage(image, i, () => openZoomModal(image)),
                    )
                  : typeof data?.bill_images === "string"
                    ? data.bill_images
                        .split(",")
                        .map((image, i) =>
                          renderImage(image.trim(), i, () =>
                            openZoomModal(image.trim()),
                          ),
                        )
                    : null}
              </TableCell>
            )}

            {tab === 3 && (
              <TableCell className="text-center">
                <span
                  onClick={
                    data.bill_status === "Paid" ||
                    data.bill_status === "Partially Paid"
                      ? () => handlePaidModalOpen(data.trip_advance)
                      : null
                  }
                  className={`text-sm ${
                    data.bill_status === "Paid"
                      ? "text-green-500"
                      : data.bill_status === "Partially Paid"
                        ? "text-orange-500"
                        : data.bill_status === "Overpaid"
                          ? "text-blue-500"
                          : "text-red-500"
                  } ${
                    data.bill_status === "Paid" ||
                    data.bill_status === "Partially Paid"
                      ? "cursor-pointer"
                      : "cursor-default"
                  }`}
                >
                  {data.bill_status === "Paid"
                    ? "Paid"
                    : data.bill_status === "Partially Paid"
                      ? "Partially Paid"
                      : data.bill_status === "Overpaid"
                        ? "Overpaid"
                        : "Unpaid"}
                </span>
              </TableCell>
            )}

            <TableCell className="text-center ">
              {data?.remark ? (
                <div className="mt-1">
                  <Tooltip
                    title={
                      <div className="text-xs">
                        Remark : {data?.remark || "-"}
                      </div>
                    }
                    placement="top"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          fontSize: "12px",
                          padding: "8px",
                          maxWidth: "300px",
                        },
                      },
                    }}
                  >
                    <span
                      className="text-blue-500 cursor-pointer inline-flex"
                      aria-label="View remark"
                    >
                      <FaInfoCircle />
                    </span>
                  </Tooltip>
                </div>
              ) : (
                <span>-</span>
              )}
            </TableCell>

            {(tab === 0 || tab === 1) && (
              <TableCell className="text-center">
                <div>
                  {Number(data.bill_verify_satus) === 2 ? (
                    <span
                      className="text-sm text-red-500 cursor-pointer"
                      onClick={() => handleOpen(data.bill_verify_reject_reason)}
                    >
                      Rejected
                    </span>
                  ) : Number(data.bill_adjusted_status) === 2 ? (
                    <span
                      className="text-sm text-orange-500 cursor-pointer"
                      onClick={() => handleOpen(data.bill_adjusted_remark)}
                    >
                      Rejected by Accounts
                    </span>
                  ) : (
                    <span className="text-sm">-</span>
                  )}
                </div>
                {data?.bill_status == "Rejected" && (
                  <div className="text-sm">
                    <Tooltip
                      title={
                        <div className="text-xs">
                          Reason : {data?.bill_verify_reject_reason || "-"}
                        </div>
                      }
                      placement="top"
                      componentsProps={{
                        tooltip: {
                          sx: {
                            fontSize: "12px",
                            padding: "8px",
                            maxWidth: "300px",
                          },
                        },
                      }}
                    >
                      <span
                        className="text-blue-500 cursor-pointer inline-flex"
                        aria-label="View remark"
                      >
                        <FaInfoCircle />
                      </span>
                    </Tooltip>
                  </div>
                )}
              </TableCell>
            )}
            {tab === 2 && (
              <TableCell className="text-center">
                <span
                  className={`font-semibold ${
                    data?.profit_label === "loss"
                      ? "text-red-600"
                      : data?.profit_label === "low profit"
                        ? "text-orange-500"
                        : data?.profit_label === "mid profit"
                          ? "text-yellow-600"
                          : "text-green-600" // profit or good profit
                  }`}
                >
                  {data?.profit_label}
                </span>
                <br />
                <br />
                {data?.profit_percentage || 0}%
              </TableCell>
            )}

            <TableCell>
              <div className="flex justify-center">
                {hideView && (
                  <div className="p-2 cursor-pointer text-gray-400 hover:text-green-600">
                    <button
                      onClick={() =>
                        handleView(data.va_id, "Purchase Bill Details")
                      }
                      className="p-2 cursor-pointer text-gray-400 hover:text-red-600 focus:outline-none"
                    >
                      <FiEye
                        id={data.id}
                        className="text-gray-600 cursor-pointer"
                        size={20}
                      />
                    </button>
                  </div>
                )}

                {/* {hideAdd && ( */}
                <div className="flex justify-center">
                  {hideAdd && tab === 0 && (
                    <div className="p-2 cursor-pointer text-gray-400 hover:text-green-600">
                      <Button
                        onClick={() => {
                          toggleDrawer({
                            billAmount: data.bill_amount,
                            vaId: data.va_id,
                          });
                          handleBill(data);
                        }}
                      >
                        {data.bill_amount > 0 ? "Modify" : "Add"}
                      </Button>
                    </div>
                  )}
                  {hideEdit && tab === 1 && (
                    <div className="p-2 cursor-pointer text-gray-400 hover:text-green-600">
                      <Button
                        onClick={() => {
                          handleVerify(data);
                        }}
                      >
                        Verify
                      </Button>
                    </div>
                  )}

                  {hideEdit && tab === 2 && (
                    <div className="p-2 cursor-pointer text-gray-400 hover:text-green-600">
                      <Button
                        onClick={() => {
                          handleApprove(data);
                        }}
                      >
                        Approve
                      </Button>
                    </div>
                  )}
                </div>
                {/* )} */}
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 300,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            borderRadius: 2,
          }}
        >
          {/* Close Icon */}
          <IconButton
            onClick={handleClose}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <MdClose size={24} />
          </IconButton>
          <Typography variant="body1" sx={{ mt: 4 }}>
            {selectedRemark}
          </Typography>
        </Box>
      </Modal>
      {isModalOpen && (
        <div
          role="dialog"
          aria-modal="true"
          className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              closeZoomModal();
            }
          }}
        >
          <div className="bg-white dark:bg-gray-600 p-4 rounded-lg max-w-md w-full relative">
            <button
              onClick={closeZoomModal}
              className="viewModelBoxCloseBtn bg-white dark:bg-gray-600 dark:text-white absolute top-2 right-2 text-2xl"
            >
              <IoIosClose />
            </button>

            {selectedImage && (
              <img
                src={process.env.REACT_APP_API_IMAGE_URL + selectedImage}
                alt="Zoomed Image"
                className="w-full max-h-[90vh] h-auto rounded-lg object-contain"
                loading="lazy"
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default DriverTable;
